import { render, staticRenderFns } from "./Packs.vue?vue&type=template&id=72da71b2"
import script from "./Packs.vue?vue&type=script&lang=js"
export * from "./Packs.vue?vue&type=script&lang=js"
import style0 from "./Packs.vue?vue&type=style&index=0&id=72da71b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports